import {
  defineNuxtRouteMiddleware,
  useNuxtApp,
  navigateTo,
  createError,
  type RouteMiddleware
} from 'nuxt/app'
import openUrl from '~/lib/url/openUrl'

export const handleEtkRoute: RouteMiddleware = async (to, from) => {
  const { name } = to
  const nuxtApp = useNuxtApp()
  const { $i18n, $api } = nuxtApp

  if (name === 'parts-catalog') {
    try {
      const { data } = await $api.etk.get(undefined, $i18n.locale)
      if (from.name === name) {
        return navigateTo(data.url, { external: true })
      } else {
        openUrl(data.url, '_blank')
        return navigateTo(from.fullPath)
      }
    } catch (e) {
      throw createError({ statusCode: 404 })
    }
  }
}

export default defineNuxtRouteMiddleware(handleEtkRoute)
